import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/shijisun/edu/projects/imui/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import './demo/demo.scss';
import Align from '../../node_modules/rc-align';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "align"
    }}>{`Align`}</h1>

    <p>{`本组件（Align）来源为`}<a parentName="p" {...{
        "href": "https://github.com/react-component/align"
      }}>{`Github`}</a></p>
    <p>{`IMUI中会使用Align作为某些组件的定位工具，故这里提供一些官方之外的使用Demo，方便IMUI开发者参考.`}</p>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`属性`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`说明`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`定位相关参数,与`}<a parentName="td" {...{
              "href": "https://github.com/yiminghe/dom-align"
            }}>{`dom-align`}</a>{`组件的属性配置相同`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onAlign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`发生align时的回调`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`function(source:HTMLElement, align:Object)`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`target`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`获取定位的目标元素`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`function():HTMLElement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`function(){return window;}`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`monitorWindowResize`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`在resize时，是否进行align重排`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.points`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`定位参数,数组第一个字符串表示要定位的元素对准点，第二个表示定位目标元素对准点。字符串包含两个字符，第1个表示纵向信息，第2个表示横向信息，字符可能的值为： 't'(top), 'b'(bottom), 'c'(center), 'l'(left), 'r'(right)`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`String[2]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.offset`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`要定位的元素的偏移,第1个值表示横向偏移，第2个表示纵向偏移`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Number[2]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.targetOffset`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`目标元素的偏移,第1个值表示横向偏移，第2个表示纵向偏移`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Number[2]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.overflow`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`是否启用视窗边缘碰撞检测。adjustX属性为true表示启用横向检测，adjustY属性为true表示启用纵向检测`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.useCssRight`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`是否使用css right替代left定位`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.useCssBottom`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`是否使用css bottom替代top定位`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`align.useCssTransform`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`当浏览器支持时，是否使用css transform替代top,left,bottom,right定位`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`bool`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`false`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "原始文档"
    }}>{`原始文档`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/react-component/align"
        }}>{`https://github.com/react-component/align`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/yiminghe/dom-align"
        }}>{`https://github.com/yiminghe/dom-align`}</a></li>
    </ul>
    <h2 {...{
      "id": "alignpoint"
    }}>{`align.point`}</h2>
    <Playground __position={0} __code={'() => {\n  let targetElems = []\n  function getTarget(index) {\n    if (!targetElems.length) {\n      targetElems = document.getElementsByClassName(\'align-demo-target\')\n    }\n    return targetElems[index - 1]\n  }\n  function getTargetFn(index) {\n    return () => {\n      return getTarget(index)\n    }\n  }\n  return (\n    <>\n      <Align\n        align={{\n          points: [\'cc\', \'cc\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">cc, cc</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'tr\', \'bl\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">tr, bl</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'br\', \'tl\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">br, tl</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'bl\', \'tr\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">bl, tr</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'tl\', \'br\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">tl, br</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'bc\', \'tc\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">bc, tc</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'tc\', \'bc\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">tc, bc</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'cr\', \'cl\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">cr, cl</div>\n      </Align>\n      <Align\n        align={{\n          points: [\'cl\', \'cr\'],\n        }}\n        target={getTargetFn(1)}\n      >\n        <div className=\"align-demo-source\">cl, cr</div>\n      </Align>\n      <div className=\"align-demo-target\">target</div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Align,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        let targetElems = [];

        function getTarget(index) {
          if (!targetElems.length) {
            targetElems = document.getElementsByClassName('align-demo-target');
          }

          return targetElems[index - 1];
        }

        function getTargetFn(index) {
          return () => {
            return getTarget(index);
          };
        }

        return <>
        <Align align={{
            points: ['cc', 'cc']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">cc, cc</div>
        </Align>
        <Align align={{
            points: ['tr', 'bl']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">tr, bl</div>
        </Align>
        <Align align={{
            points: ['br', 'tl']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">br, tl</div>
        </Align>
        <Align align={{
            points: ['bl', 'tr']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">bl, tr</div>
        </Align>
        <Align align={{
            points: ['tl', 'br']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">tl, br</div>
        </Align>
        <Align align={{
            points: ['bc', 'tc']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">bc, tc</div>
        </Align>
        <Align align={{
            points: ['tc', 'bc']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">tc, bc</div>
        </Align>
        <Align align={{
            points: ['cr', 'cl']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">cr, cl</div>
        </Align>
        <Align align={{
            points: ['cl', 'cr']
          }} target={getTargetFn(1)} mdxType="Align">
          <div className="align-demo-source">cl, cr</div>
        </Align>
        <div className="align-demo-target">target</div>
    </>;
      }}
    </Playground>
    <h2 {...{
      "id": "alignoffset"
    }}>{`align.offset`}</h2>
    <Playground __position={1} __code={'() => {\n  let targetElems = []\n  function getTarget(index) {\n    if (!targetElems.length) {\n      targetElems = document.getElementsByClassName(\'align-demo-target\')\n    }\n    return targetElems[index - 1]\n  }\n  function getTargetFn(index) {\n    return () => {\n      return getTarget(index)\n    }\n  }\n  return (\n    <>\n      <Align\n        align={{\n          points: [\'cc\', \'cc\'],\n          offset: [10, 20],\n        }}\n        target={getTargetFn(2)}\n      >\n        <div className=\"align-demo-source\"></div>\n      </Align>\n      <Align\n        align={{\n          points: [\'cc\', \'cc\'],\n        }}\n        target={getTargetFn(2)}\n      >\n        <div className=\"align-demo-source align-demo-source--border\"></div>\n      </Align>\n      <span>point: [\'cc\', \'cc\'], offset: [10, 20]</span>\n      <div className=\"align-demo-target\">target</div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Align,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        let targetElems = [];

        function getTarget(index) {
          if (!targetElems.length) {
            targetElems = document.getElementsByClassName('align-demo-target');
          }

          return targetElems[index - 1];
        }

        function getTargetFn(index) {
          return () => {
            return getTarget(index);
          };
        }

        return <>
    <Align align={{
            points: ['cc', 'cc'],
            offset: [10, 20]
          }} target={getTargetFn(2)} mdxType="Align">
          <div className="align-demo-source"></div>
        </Align>
        <Align align={{
            points: ['cc', 'cc']
          }} target={getTargetFn(2)} mdxType="Align">
          <div className="align-demo-source align-demo-source--border"></div>
        </Align>
        <span>point: ['cc', 'cc'], offset: [10, 20]</span>
        <div className="align-demo-target">target</div>
    </>;
      }}
    </Playground>
    <h2 {...{
      "id": "aligntargetoffset"
    }}>{`align.targetOffset`}</h2>
    <Playground __position={2} __code={'() => {\n  let targetElems = []\n  function getTarget(index) {\n    if (!targetElems.length) {\n      targetElems = document.getElementsByClassName(\'align-demo-target\')\n    }\n    return targetElems[index - 1]\n  }\n  function getTargetFn(index) {\n    return () => {\n      return getTarget(index)\n    }\n  }\n  return (\n    <>\n      <Align\n        align={{\n          points: [\'cc\', \'cc\'],\n          targetOffset: [10, 20],\n        }}\n        target={getTargetFn(3)}\n      >\n        <div className=\"align-demo-source\"></div>\n      </Align>\n      <Align\n        align={{\n          points: [\'cc\', \'cc\'],\n        }}\n        target={getTargetFn(3)}\n      >\n        <div className=\"align-demo-source align-demo-source--border\"></div>\n      </Align>\n      <span>point: [\'cc\', \'cc\'], targetOffset偏移: [10, 20]</span>\n      <div className=\"align-demo-target\">target</div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Align,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        let targetElems = [];

        function getTarget(index) {
          if (!targetElems.length) {
            targetElems = document.getElementsByClassName('align-demo-target');
          }

          return targetElems[index - 1];
        }

        function getTargetFn(index) {
          return () => {
            return getTarget(index);
          };
        }

        return <>
    <Align align={{
            points: ['cc', 'cc'],
            targetOffset: [10, 20]
          }} target={getTargetFn(3)} mdxType="Align">
          <div className="align-demo-source"></div>
        </Align>
        <Align align={{
            points: ['cc', 'cc']
          }} target={getTargetFn(3)} mdxType="Align">
          <div className="align-demo-source align-demo-source--border"></div>
        </Align>
        <span>point: ['cc', 'cc'], targetOffset偏移: [10, 20]</span>
        <div className="align-demo-target">target</div>
    </>;
      }}
    </Playground>
    <h2 {...{
      "id": "alignoverflow"
    }}>{`align.overflow`}</h2>
    <Playground __position={3} __code={'() => {\n  let targetElems = []\n  function getTarget(index) {\n    if (!targetElems.length) {\n      targetElems = document.getElementsByClassName(\'align-demo-target\')\n    }\n    return targetElems[index - 1]\n  }\n  function getTargetFn(index) {\n    return () => {\n      return getTarget(index)\n    }\n  }\n  return (\n    <>\n      <Align\n        align={{\n          points: [\'tl\', \'br\'],\n        }}\n        target={getTargetFn(4)}\n      >\n        <div className=\"align-demo-source align-demo-source--large align-demo-source--border\"></div>\n      </Align>\n      <Align\n        align={{\n          points: [\'tl\', \'br\'],\n          overflow: {\n            adjustX: true,\n          },\n        }}\n        target={getTargetFn(4)}\n        monitorWindowResize\n      >\n        <div className=\"align-demo-source align-demo-source--large\"></div>\n      </Align>\n      <span>尝试改变浏览器窗口大小，使浏览器边缘靠近橙色方块</span>\n      <div className=\"align-demo-target align-demo-target--large\">target</div>\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Align,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
      {() => {
        let targetElems = [];

        function getTarget(index) {
          if (!targetElems.length) {
            targetElems = document.getElementsByClassName('align-demo-target');
          }

          return targetElems[index - 1];
        }

        function getTargetFn(index) {
          return () => {
            return getTarget(index);
          };
        }

        return <>
    <Align align={{
            points: ['tl', 'br']
          }} target={getTargetFn(4)} mdxType="Align">
          <div className="align-demo-source align-demo-source--large align-demo-source--border"></div>
        </Align>
        <Align align={{
            points: ['tl', 'br'],
            overflow: {
              adjustX: true
            }
          }} target={getTargetFn(4)} monitorWindowResize mdxType="Align">
          <div className="align-demo-source align-demo-source--large"></div>
        </Align>
        <span>尝试改变浏览器窗口大小，使浏览器边缘靠近橙色方块</span>
        <div className="align-demo-target align-demo-target--large">target</div>
    </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      